



















import { Component, Vue, Watch } from 'vue-property-decorator'
import SubSearch from '@/components/party/search/SubSearch.vue'

@Component({
  components: { SubSearch }
})
export default class Search extends Vue {
  private name = 'Search'
  private query = ''
}
